import React from "react";

export const Logo = ({ className }) => {
  return (
    <svg
      className={`logo ${className}`}
      fill="none"
      height="39"
      viewBox="0 0 168 39"
      width="168"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M26.9339 37.4585C24.0935 38.6681 21.0068 39.1777 17.9309 38.9447C14.8551 38.7117 11.8791 37.7429 9.25098 36.119L12.2971 33.0557C13.1857 33.5281 14.1195 33.9088 15.0844 34.1919C17.8957 35.0162 20.8826 35.0162 23.6939 34.1919L26.9339 37.4585Z"
        fill="white"
      />

      <path
        className="path"
        d="M38.7692 19.4966C38.7766 23.8747 37.3128 28.1269 34.6154 31.5634C34.0414 32.293 33.4178 32.9815 32.7489 33.6242L29.808 30.6666C29.9257 30.5566 30.0434 30.4425 30.1583 30.3269C30.6987 29.784 31.1981 29.2013 31.6523 28.5836C33.323 26.3023 34.3318 23.5998 34.5666 20.7764C34.8013 17.9531 34.2527 15.1196 32.9818 12.5911C31.711 10.0625 29.7676 7.93798 27.3679 6.45372C24.9681 4.96946 22.2061 4.18364 19.3888 4.18364C16.5715 4.18364 13.8094 4.96946 11.4096 6.45372C9.00988 7.93798 7.06653 10.0625 5.79566 12.5911C4.5248 15.1196 3.97623 17.9531 4.21095 20.7764C4.44567 23.5998 5.45449 26.3023 7.12523 28.5836L4.16215 31.5634C2.24816 29.122 0.942535 26.2558 0.354238 23.2037C-0.234059 20.1517 -0.0879685 17.0024 0.780321 14.0187C1.64861 11.035 3.21392 8.30337 5.34561 6.05183C7.4773 3.80029 10.1136 2.09412 13.0344 1.07569C15.9552 0.0572576 19.0759 -0.243896 22.136 0.197366C25.1961 0.638627 28.1069 1.80951 30.6255 3.61229C33.144 5.41507 35.1973 7.79746 36.614 10.5607C38.0307 13.3239 38.7696 16.3877 38.7692 19.4966Z"
        fill="white"
      />

      <path
        className="path"
        d="M32.7444 33.6244L32.7154 33.6523C31.9311 34.3903 30.8917 34.7922 29.8178 34.7727C28.7438 34.7532 27.7196 34.3139 26.9623 33.5479L20.7911 27.3418C20.6066 27.1555 20.3874 27.0078 20.1459 26.9069C19.9045 26.8061 19.6457 26.7542 19.3843 26.7542C19.1229 26.7542 18.8641 26.8061 18.6227 26.9069C18.3812 27.0078 18.162 27.1555 17.9775 27.3418L9.25447 36.1141C8.09565 35.3981 7.01439 34.5623 6.02832 33.6203L15.1294 24.4678C16.1403 23.449 17.4799 22.8269 18.9066 22.7134C19.2279 22.7622 19.5546 22.7622 19.8758 22.7134C21.3026 22.8269 22.6421 23.449 23.6531 24.4678L32.7444 33.6244Z"
        fill="white"
      />

      <path
        className="path"
        d="M26.5471 19.4968C26.549 20.5259 26.3309 21.5435 25.9076 22.4804C25.4843 23.4174 24.8656 24.2518 24.0935 24.9273L23.6449 24.4761C22.634 23.4573 21.2944 22.8352 19.8677 22.7217C20.6757 22.5988 21.4077 22.1733 21.917 21.5305C22.4263 20.8878 22.6752 20.0752 22.6139 19.2557C22.5526 18.4362 22.1857 17.6702 21.5865 17.1113C20.9874 16.5524 20.2003 16.2418 19.3831 16.2418C18.5658 16.2418 17.7788 16.5524 17.1796 17.1113C16.5805 17.6702 16.2135 18.4362 16.1522 19.2557C16.0909 20.0752 16.3398 20.8878 16.8491 21.5305C17.3584 22.1733 18.0904 22.5988 18.8984 22.7217C17.4717 22.8352 16.1322 23.4573 15.1212 24.4761L14.6781 24.9273C13.7753 24.1352 13.0845 23.128 12.669 21.9978C12.2535 20.8677 12.1266 19.6508 12.3 18.4586C12.4733 17.2664 12.9413 16.1369 13.6611 15.1737C14.381 14.2105 15.3296 13.4444 16.4202 12.9454C17.5108 12.4464 18.7084 12.2306 19.9034 12.3177C21.0984 12.4047 22.2526 12.792 23.2602 13.4438C24.2679 14.0957 25.0968 14.9914 25.671 16.0489C26.2452 17.1064 26.5464 18.2919 26.5471 19.4968Z"
        fill="white"
      />

      <path
        className="path"
        d="M76.9174 10.4775C76.792 10.261 76.6117 10.0813 76.3946 9.95637C76.1776 9.83141 75.9313 9.76562 75.6807 9.76562C75.4301 9.76562 75.1838 9.83141 74.9668 9.95637C74.7497 10.0813 74.5694 10.261 74.444 10.4775L64.5117 27.6348C66.4237 24.949 69.2436 23.0423 72.4527 22.2652L75.6795 16.6924L78.9014 22.2639C82.1056 23.0385 84.9224 24.9394 86.8352 27.6179L76.9174 10.4775Z"
        fill="white"
      />

      <g className="g" opacity="0.6">
        <path
          className="path"
          d="M76.9174 10.4775C76.792 10.261 76.6117 10.0813 76.3946 9.95637C76.1776 9.83141 75.9313 9.76562 75.6807 9.76562C75.4301 9.76562 75.1838 9.83141 74.9668 9.95637C74.7497 10.0813 74.5694 10.261 74.444 10.4775L64.5117 27.6348C66.4237 24.949 69.2436 23.0423 72.4527 22.2652L75.6795 16.6924L78.9014 22.2639C82.1056 23.0385 84.9224 24.9394 86.8352 27.6179L76.9174 10.4775Z"
          fill="url(#paint0_linear_3091_10552)"
        />
      </g>

      <path
        className="path"
        d="M58.7078 13.9399V29.2503H54.5203V13.9399H46.8457V9.76416H66.3824V13.9399H58.7078Z"
        fill="white"
      />

      <path
        className="path"
        d="M105.615 22.1163V9.75635H109.801V29.2425H106.843L94.4509 16.8826V29.2425H90.2646V9.76116H93.2226L105.615 22.1163Z"
        fill="white"
      />

      <path
        className="path"
        d="M130.084 22.1163V9.75635H134.27V29.2425H131.311L118.92 16.8826V29.2425H114.733V9.76116H117.691L130.084 22.1163Z"
        fill="white"
      />

      <path
        className="path"
        d="M143.15 29.2469H138.964V9.76074H143.15V29.2469Z"
        fill="white"
      />

      <path
        className="path"
        d="M159.708 13.9399V29.2503H155.517V13.9399H147.843V9.76416H167.379V13.9399H159.708Z"
        fill="white"
      />

      <path
        className="path"
        d="M87.7752 29.2469H82.9646C82.9333 29.2144 82.9055 29.1783 82.8718 29.1459C81.9656 28.128 80.8528 27.3141 79.6072 26.7579C78.3615 26.2018 77.0116 25.9163 75.6469 25.9202C74.2822 25.9242 72.934 26.2176 71.6916 26.781C70.4493 27.3444 69.3413 28.1648 68.4411 29.188C68.423 29.2072 68.4061 29.2288 68.3868 29.2469H63.5762L64.5091 27.6346C65.7737 25.8571 67.4464 24.4073 69.3874 23.4062C71.3285 22.4052 73.4814 21.882 75.6665 21.8804C77.8516 21.8787 80.0054 22.3987 81.9479 23.3968C83.8904 24.3949 85.5653 25.8422 86.8326 27.6177L87.7752 29.2469Z"
        fill="white"
      />

      <defs className="defs">
        <linearGradient
          className="linear-gradient"
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_3091_10552"
          x1="75.8615"
          x2="75.6264"
          y1="17.2178"
          y2="30.4518"
        >
          <stop className="stop" stopColor="#020202" stopOpacity="0" />

          <stop className="stop" offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};
